module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('display', [_c('path-line', {
    attrs: {
      "file-name": "colours"
    },
    slot: "path"
  }), _vm._v(" "), _c('p', {
    slot: "intro"
  }, [_vm._v("\n    All UI components are styled with our brand colours. These brand colour names are to be kept generic and detached\n    from the colours they hold to enable future changes.\n  ")]), _vm._v(" "), _c('template', {
    slot: "sections"
  }, _vm._l((Object.keys(_vm.colours).reverse()), function(colourGroup) {
    return _c('display-section', {
      attrs: {
        "title": colourGroup
      }
    }, [_c('p', {
      slot: "description"
    }, [_vm._v(_vm._s(_vm.description[colourGroup]))]), _vm._v(" "), _vm._l((Object.keys(_vm.colours[colourGroup]).reverse()), function(colour) {
      return _c('example', {
        key: colour,
        attrs: {
          "var-name": colour
        },
        slot: "examples"
      }, [_c('div', {
        staticClass: "colour-swatch",
        class: colour
      }, [_vm._v(_vm._s(colour))])])
    })], 2)
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-af0b7832"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vars/colours.vue
// module id = 1466
// module chunks = 1